import { colors, Stack, Typography } from '@ui-components/neo.tax';
import { ReactComponent as QuestionMarkIcon } from '@ui-components/neo.tax/dist/icons/question-mark.svg';
import { ReactComponent as ExternalLinkIcon } from '@ui-components/neo.tax/dist/icons/share-external-link-1.svg';
import { useMenuState, Menu as AriaMenu } from 'ariakit';
import React, { ReactElement } from 'react';

import { HELP_INVITE_TEAM_MEMBERS_URL, HELP_PAGE_BASE_URL } from '@neo.tax/shared/constants';

import { MenuItemDivider } from '../notification-menu/notification-menu.styled';
import { MenuButton, MenuItem, StyledLink, StyledStack } from './help-menu.styled';

export const HelpMenu = (): ReactElement => {
  const menuState = useMenuState({ gutter: 4 });
  return (
    <>
      <MenuButton state={menuState}>
        <QuestionMarkIcon width={20} color={colors.gray[400]} />
      </MenuButton>
      <StyledStack
        as={AriaMenu}
        state={menuState}
        backgroundColor={colors.white}
        boxShadow="md"
        borderRadius="md"
        direction="column"
      >
        <Stack paddingX={2} paddingY={2} justifyContent="center">
          <Typography color={colors.gray[600]} fontSize="xs" fontWeight="medium">
            Help & Support
          </Typography>
        </Stack>
        <MenuItemDivider />
        <Stack paddingX={2} direction="column" justifyContent="center">
          <MenuItem>
            <Stack paddingY={1} alignItems="center" justifyContent="center" fullWidth>
              <StyledLink
                as="a"
                href={HELP_INVITE_TEAM_MEMBERS_URL}
                target="_blank"
                rel="noopener noreferrer"
                fontSize="xs"
                color={colors.gray[600]}
              >
                Invite Team Members <ExternalLinkIcon width={12} color={colors.gray[400]} />
              </StyledLink>
            </Stack>
          </MenuItem>
          <MenuItemDivider />
          <MenuItem>
            <Stack paddingY={1} alignItems="center" justifyContent="center" fullWidth>
              <StyledLink
                as="a"
                href={HELP_PAGE_BASE_URL}
                target="_blank"
                rel="noopener noreferrer"
                fontSize="xs"
                color={colors.gray[600]}
              >
                Help Center <ExternalLinkIcon width={12} color={colors.gray[400]} />
              </StyledLink>
            </Stack>
          </MenuItem>
        </Stack>
      </StyledStack>
    </>
  );
};
